/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by  Warren Dowey
 */

import { Injectable } from '@angular/core';
import { SessionHistoryModel } from '@app/models/session-history.model';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { CREATE_SESSION_HISTORY, GET_SESSION_HISTORY_BY_ID } from './session-history-queries';
@Injectable({
  providedIn: 'root',
})
export class SessionHistoryService {
  sessionHistory: SessionHistoryModel;

  constructor(
    private apollo: Apollo
  ) {
  }

  public insertData(sessionHistory: SessionHistoryModel): Observable<String> {
    return new Observable(subscriber => {
      this.apollo.mutate({
        mutation: CREATE_SESSION_HISTORY,
        variables: {
          input: {
            sessionHistory: sessionHistory
          }
        }
      }).subscribe(res => {
        subscriber.next();
        subscriber.complete();
      })
    })
  }

  public getSessionHistoryById(sessionHistoryId: string): Observable<SessionHistoryModel> {
    if (!!this.sessionHistory) {
      return new Observable(subscriber => {
        subscriber.next(this.sessionHistory);
        subscriber.complete();
      });
    } else {
      return new Observable(subscriber => {
        this.apollo.query({
          query: GET_SESSION_HISTORY_BY_ID,
          variables: {
            sessionHistoryId: sessionHistoryId
          }
        }).subscribe((res: any) => {
          this.sessionHistory = res.sessionHistory;
          subscriber.next(this.sessionHistory);
          subscriber.complete();
        });
      });
    }
  }
}
